// https://stackoverflow.com/a/13653180
const uuidRegex =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Test if the given uuid is a valid UUID
 * @param uuid UUID to test
 */
export const isValidUUID = (uuid?: string | null): boolean => {
  if (!uuid) return false;
  return uuidRegex.test(uuid);
};

/**
 * Test if the given uuid is not a valid UUID
 * @param uuid UUID to test
 */
export const isNotValidUUID = (uuid?: string | null): boolean => {
  return !isValidUUID(uuid);
};
